import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useTheme } from '../../contexts/ThemeContext';
import { useCompanyStats } from '../../services/hooks/useCompanyStats';

interface LayoutProps {
    ownerName: string;
    onLogout: () => void;
    isAdmin?: boolean;
    companyId?: string;
    onCreateCompany?: () => void;
    onCreateComplex?: () => void;
    userRole?: string;
}

export const Layout: React.FC<LayoutProps> = ({
    ownerName,
    onLogout,
    isAdmin = false,
    companyId,
    onCreateCompany,
    onCreateComplex,
    userRole
}) => {
    const { theme } = useTheme();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const { data: companyStats } = useCompanyStats(companyId);
    const companyName = companyStats?.companyName || 'No Company';

    return (
        <div className={`min-h-screen flex overflow-x-hidden ${theme === 'dark' ? 'bg-storgia-black' : 'bg-gray-50'}`}>
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-black focus:rounded focus:shadow-lg"
            >
                Skip to main content
            </a>
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
                isCollapsed={isCollapsed}
                toggleCollapse={() => setIsCollapsed(!isCollapsed)}
                onLogout={onLogout}
                ownerName={ownerName}
                isAdmin={isAdmin}
                onCreateCompany={onCreateCompany}
                onCreateComplex={onCreateComplex}
            />

            <div className={`flex-1 flex flex-col transition-all duration-300 ${isCollapsed ? 'lg:pl-20' : 'lg:pl-72'}`}>
                <Header
                    onMenuClick={() => setIsSidebarOpen(true)}
                    searchTerm={searchTerm}
                    onSearchChange={setSearchTerm}
                    ownerName={ownerName}
                    onLogout={onLogout}
                    companyName={companyName}
                    userRole={userRole}
                />

                <main id="main-content" className="flex-1 p-6 overflow-x-hidden">
                    <Outlet context={{ searchTerm }} />
                </main>
            </div>
        </div>
    );
};
